import React from 'react'
import { HashRouter } from 'react-router-dom'

import 'semantic-ui-css/semantic.min.css';

import './App.css'

import RootRouter from './routers/RootRouter'

const App = () => (
  <HashRouter>
    <RootRouter />
  </HashRouter>
)

export default App



// WEBPACK FOOTER //
// ./src/App.js